import PropTypes from "prop-types"

const SOLUTION = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
})

const SOLUTIONS = PropTypes.arrayOf(SOLUTION)

export {
  SOLUTION,
  SOLUTIONS,
}
